import { isMobileScreen } from "../../scripts/utility/is-mobile";

export function stickyCart() {
    applyStickyCart(
        document.querySelector("#shopify-section-product-template .buttoxn-sticky")
    );
    applyStickyCart(
        document.querySelector(
            "#shopify-section-cart-template .sticky-container #update-cart"
        )
    );
}

export function applyStickyCart(el) {
    if (el) {
        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.1,
        });
        document.querySelectorAll("[data-hide-sticky]").forEach((target) => {
            observer.observe(target);
        });
        function handleIntersection(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting || !isMobileScreen) {
                    el.parentElement.classList.add("u-hidden");
                } else {
                    el.parentElement.classList.remove("u-hidden");
                }
            });
        }
    }
}

//INIT 

stickyCart();
window.addEventListener("resize", function () {
    stickyCart();
})